module.exports = __webpack_public_path__ + "img/sample2-voronoi-inverse-high.910d651f.png";